import { Accordion, Form, Tab, Tabs } from "react-bootstrap";
import { TopBar } from "../../shared/topBar/TopBar";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {  getDyanmicContactList, getStaticContactList } from "../../actions/contactListAction";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { DynamicList } from "./DynamicList";
import { StaticList } from "./StaticList";

export const Lists = () => {
  
    const [render, setRender] = useState(false);
    useEffect(() => {
        document.title = `Lists`;
     },[])
    // useEffect(() => {
    //     dispatch(getStaticContactList());
    //     dispatch(getDyanmicContactList());
    // }, [render]);
    const Level = [{ BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` },{ BreadCrumb: "Lists", Routes: `${UrlPath.InvestorLists}` }]
    return <>
        <TopBar label={"Lists"} />
        <div id="InvestorLists" className="mainContentData">
        <BreadCrumbs Levels={Level} />
            <div className="tabContainer container-fluid">
                <Tabs id="uncontrolled-tab-example" className="ms-3 borderbtm0">
                    <Tab eventKey="DynamicList" title="Dynamic List"  >
                        <div className="p-3 bg-white life-science rounded"><DynamicList setRender={setRender} render={render} /></div>
                    </Tab>
                    <Tab eventKey="StaticList" title="Static List" >
                        <div className="p-3 bg-white life-science rounded"><StaticList setRender={setRender} render={render} /></div>
                    </Tab>
                </Tabs>
            </div>
        </div>
        <ToastContainer />
    </>
};
